import React from 'react';
import { normalizeLov } from 'utils/jsonhandlers/notekeys';

// Read-only Level of Visit for the Edit screens, with the AI's reasoning
// under it. LOV is billing metadata estimated by the backend, not a note
// section: it is not editable here and is not printed on the PDF.
const LevelOfVisitChip = ({ noteJson, className = '' }) => {
  const level = normalizeLov(noteJson?.level_of_visit);
  if (!level) {
    return null;
  }
  const reasoning = typeof noteJson?.level_of_visit_reasoning === 'string'
    ? noteJson.level_of_visit_reasoning.trim()
    : '';

  return (
    <div className={`rounded-lg border border-[#F5DED4] bg-[#FDF6F3] px-3 py-2 text-left ${className}`}>
      <span
        title="Estimated by BlinkScribe. Read-only."
        className="inline-block rounded-md bg-[#1C2A3A] px-2 py-0.5 text-xs font-bold text-white whitespace-nowrap"
      >
        Level of Visit: {level}
      </span>
      {reasoning ? (
        <p className="mt-1 mb-0 text-xs text-[#374151] whitespace-pre-line break-words">{reasoning}</p>
      ) : null}
    </div>
  );
};

export default LevelOfVisitChip;
